import styles from './styles.module.scss';
import Loading from 'components/loading';
import Icon from 'icons';
import classNames from 'classnames';
import global from 'global';
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import ModalUpdateSum from '../modal-update-sum';

import modalStyles from '../modal-update-sum/styles.module.scss';

export default function ResultSection({
  pending,
  contextApplication,
  result,
}: {
  pending: boolean;
  contextApplication: global.contextApplicationCollateral;
  result?: boolean;
}) {
  const [openModal, setOpenModal] = React.useState(false);

  return (
    <div className={styles.result}>
      {pending && (
        <div className={styles.resultBox}>
          <Loading size={50} />
        </div>
      )}
      {!!contextApplication.data?.scoring_gold_log && (
        <div className={styles.resultBox}>
          <div className={styles.resultBox_title}>Статус заявки</div>
          <Icon
            size={120}
            name={
              contextApplication.data.scoring_gold_log.is_approved ? 'tickCircle' : 'closeFilled'
            }
            className={classNames(
              contextApplication.data.scoring_gold_log.is_approved
                ? styles.resultBox_icon_success
                : styles.resultBox_icon_error,
            )}
          />

          <div className={styles.resultBox_resultText}>
            <p>{contextApplication.data.scoring_gold_log.is_approved ? 'Одобрено' : 'Отказано'}</p>
            <p>{Math.round(contextApplication.data.scoring_gold_log.prediction)}% </p>
          </div>
          <div className={styles.resultBox_resultText}>
            <p>Порог</p>
            <p>{contextApplication.data.scoring_gold_log.threshold * 100}%</p>
          </div>
          {/* {!result && !contextApplication.data.has_amount_changed && (
            <Button color="orange" onClick={() => setOpenModal(true)}>
              Обновить сумму
            </Button>
          )} */}
        </div>
      )}

      {!result && !contextApplication?.data?.has_amount_changed && (
        <CSSTransition
          in={openModal}
          timeout={150}
          unmountOnExit
          classNames={{
            enter: modalStyles.modalEnter,
            enterActive: modalStyles.modalEnterActive,
            exit: modalStyles.modalExit,
            exitActive: modalStyles.modalExitActive,
          }}
        >
          <ModalUpdateSum onClose={() => setOpenModal(false)} />
        </CSSTransition>
      )}
    </div>
  );
}
